import { shoppingSessionContext } from './shoppingSessionContext';
import { useEvents } from './useEvents';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShoppingContextProvider = ({
  eventNames,
  children
}) => {
  const contextValue = useEvents(eventNames);
  return /*#__PURE__*/_jsx(shoppingSessionContext.Provider, {
    value: contextValue,
    children: children
  });
};
//# sourceMappingURL=ShoppingContextProvider.js.map